import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';

import SectionForm from './sections/Form';
import { RegisterFormTranslations } from './sections/Form/types';
import StyledComponent from './styles';
import { Props } from './types';

const PageRegisterCompany: NextPage<Props> = ({ localTranslations, metaTranslations }) => {
    const sections: PageSection[] = useMemo(() => [{
        slug: 'form',
        order: 1,
        isVisible: true,
        children: (slug, translations) => (
            <SectionForm
                key={slug}
                translations={translations as RegisterFormTranslations}
            />
        ),
    }], []);

    return (
        <StyledComponent className="page-register-company">
            <Head
                {...metaTranslations}
            />
            <PageContainer>
                <SectionsWrapper
                    sections={sections}
                    localTranslations={localTranslations}
                />
            </PageContainer>
        </StyledComponent>
    );
};

export default PageRegisterCompany;
